import React, { useEffect, useState } from 'react';
// import styles from './ClaimTimeLinePage.module.scss';
// import { MDBox } from '../../components/MDBox';
// import { MDTypography } from '../../components/MDTypography';
// import { MDButton } from '../../components/MDButton';
// // import { MDBadge } from '../../components/MDBadge';
// import {
//   ClaimDetailsData,
//   ClaimDocument,
//   ClaimService,
// } from './ClaimDetailsTypes';
// // import { mockClaimData } from './mockClaimData';
// import {
//   formatCurrency,
//   formatDate,
//   getMedicareMultiplierClass,
//   formatMedicareMultiplier,
//   generateDocumentFilename,
// } from './claimUtils';

// // Icons
// import VerifiedIcon from '@mui/icons-material/Verified';
// import WarningIcon from '@mui/icons-material/Warning';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import FileDownloadIcon from '@mui/icons-material/FileDownload';
// import CloseIcon from '@mui/icons-material/Close';
// import { getClaimDetails } from 'services/claimsService';

type ClaimTimeLinePageProps = {
  claimId: string;
  onClose: () => void;
  isVisible: boolean;
};

export function ClaimTimeLinePage({
  claimId,
  onClose,
  isVisible,
}: ClaimTimeLinePageProps) {

  return null;
  // const [isAnimating, setIsAnimating] = useState(false);
  // // const [claimData, setClaimData] = useState<ClaimDetailsData | null>(null);
  // const [pageData, setPageData] = useState<{
  //   claim: ClaimDetailsData | undefined;
  //   status: 'loading' | 'done' | 'error';
  //   error: null | Error;
  // }>({
  //   claim: undefined,
  //   status: 'loading',
  //   error: null,
  // });
  // const [selectedDocument, setSelectedDocument] =
  //   useState<ClaimDocument | null>(null);

  // // In a real implementation, this would fetch data from an API
  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const claim = (await getClaimDetails(claimId)) as any;
  //       setPageData({
  //         claim,
  //         status: 'done',
  //         error: null,
  //       });
  //     } catch (error) {
  //       const e = error as Error;
  //       setPageData({ claim: undefined, status: 'error', error: e });
  //     }
  //   };
  //   fetchData();
  // }, [claimId]);

  // useEffect(() => {
  //   if (isVisible) {
  //     setIsAnimating(true);
  //   }
  // }, [isVisible]);

  // const handleDocumentClick = (document: ClaimDocument) => {
  //   setSelectedDocument(document);
  // };

  // const handleCloseModal = () => {
  //   setSelectedDocument(null);
  // };

  // const handleDownloadDocument = (
  //   claimeDocument: ClaimDocument,
  //   event: React.MouseEvent
  // ) => {
  //   event.stopPropagation();
  //   if (claimData) {
  //     const filename = generateDocumentFilename(
  //       claimData.member.policyNumber,
  //       claimeDocument.id,
  //       claimeDocument.title
  //     );
  //     const link = document.createElement('a');
  //     link.href = claimeDocument.url;
  //     link.setAttribute('download', filename);
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //   }
  // };

  // if (pageData.status === 'loading') {
  //   return (
  //     <MDBox
  //       className={`${styles.claimTimelinePage} ${
  //         isVisible ? styles.slideIn : styles.slideOut
  //       } ${isAnimating ? styles.animate : ''}`}
  //       onAnimationEnd={() => !isVisible && setIsAnimating(false)}
  //     >
  //       <button className={styles.closeButton} onClick={onClose}>
  //         <CloseIcon />
  //       </button>
  //       <MDBox
  //         className={styles.content}
  //         display="flex"
  //         justifyContent="center"
  //         alignItems="center"
  //         height="100%"
  //       >
  //         <MDTypography>Loading claim data...</MDTypography>
  //       </MDBox>
  //     </MDBox>
  //   );
  // }

  // if (pageData.status === 'error' || !pageData.claim) {
  //   return (
  //     <MDBox
  //       className={`${styles.claimTimelinePage} ${
  //         isVisible ? styles.slideIn : styles.slideOut
  //       } ${isAnimating ? styles.animate : ''}`}
  //       onAnimationEnd={() => !isVisible && setIsAnimating(false)}
  //     >
  //       <button className={styles.closeButton} onClick={onClose}>
  //         <CloseIcon />
  //       </button>
  //       <MDBox
  //         className={styles.content}
  //         display="flex"
  //         justifyContent="center"
  //         alignItems="center"
  //         height="100%"
  //       >
  //         <MDTypography color="error">
  //           Error loading claim data: {pageData.error?.message}
  //         </MDTypography>
  //       </MDBox>
  //     </MDBox>
  //   );
  // }

  // const claimData = pageData.claim;

  // return (
  //   <>
  //     <MDBox
  //       className={`${styles.claimTimelinePage} ${
  //         isVisible ? styles.slideIn : styles.slideOut
  //       } ${isAnimating ? styles.animate : ''}`}
  //       onAnimationEnd={() => !isVisible && setIsAnimating(false)}
  //     >
  //       <button className={styles.closeButton} onClick={onClose}>
  //         <CloseIcon />
  //       </button>
  //       <MDBox className={styles.content}>
  //         {/* Header Section */}
  //         <MDBox mb={3}>
  //           <MDTypography variant="h4">
  //             Policy {claimData.member.policyNumber}
  //           </MDTypography>
  //           <MDTypography variant="body2">
  //             Member: {claimData.member.firstName} {claimData.member.lastName}
  //           </MDTypography>
  //         </MDBox>

  //         {/* VOB Status Section */}
  //         <MDBox
  //           className={`${styles.vobSection} ${
  //             claimData.vobIssued ? styles.vobIssued : styles.vobNotIssued
  //           }`}
  //         >
  //           <MDBox className={styles.vobIcon}>
  //             {claimData.vobIssued ? (
  //               <VerifiedIcon color="success" fontSize="large" />
  //             ) : (
  //               <WarningIcon color="warning" fontSize="large" />
  //             )}
  //           </MDBox>
  //           <MDBox>
  //             <MDTypography variant="h6">
  //               {claimData.vobIssued
  //                 ? 'Verification of Benefits (VOB) Issued'
  //                 : 'No Verification of Benefits (VOB) Issued'}
  //             </MDTypography>
  //             <MDTypography variant="body2">
  //               {claimData.vobIssued
  //                 ? `VOB issued on ${formatDate(claimData.vobIssuedDate!)}. ${
  //                     claimData.vobDetails
  //                   }`
  //                 : 'No VOB was requested or issued for this claim.'}
  //             </MDTypography>
  //           </MDBox>
  //         </MDBox>

  //         {/* Claim Service Details Section */}
  //         <MDBox mb={4}>
  //           <MDTypography variant="h5" className={styles.sectionTitle}>
  //             Claim Details
  //           </MDTypography>
  //           <MDBox className={styles.sectionContent}>
  //             <div className={styles.infoRow}>
  //               <div className={styles.infoLabel}>Claim ID:</div>
  //               <div className={styles.infoValue}>{claimData.id}</div>
  //             </div>
  //             <div className={styles.infoRow}>
  //               <div className={styles.infoLabel}>Service Date:</div>
  //               <div className={styles.infoValue}>
  //                 {formatDate(claimData.dateOfService)}
  //               </div>
  //             </div>
  //             <div className={styles.infoRow}>
  //               <div className={styles.infoLabel}>Provider:</div>
  //               <div className={styles.infoValue}>
  //                 {claimData.provider.name}
  //               </div>
  //             </div>
  //             <div className={styles.infoRow}>
  //               <div className={styles.infoLabel}>Provider NPI:</div>
  //               <div className={styles.infoValue}>{claimData.provider.npi}</div>
  //             </div>
  //             <div className={styles.infoRow}>
  //               <div className={styles.infoLabel}>Status:</div>
  //               <div className={styles.infoValue}>
  //                 {claimData.status}
  //                 {/* <MDBadge color={claimData.status === 'Collected' ? 'success' : 'warning'}>
  //                 </MDBadge> */}
  //               </div>
  //             </div>
  //             <div className={styles.infoRow}>
  //               <div className={styles.infoLabel}>Total Billed:</div>
  //               <div className={styles.infoValue}>
  //                 {formatCurrency(claimData.totalBilledAmount)}
  //                 <span
  //                   className={`${styles.medicareMultiplier} ${
  //                     styles[
  //                       getMedicareMultiplierClass(
  //                         claimData.totalMedicareMultiplier
  //                       )
  //                     ]
  //                   }`}
  //                 >
  //                   {formatMedicareMultiplier(
  //                     claimData.totalMedicareMultiplier
  //                   )}
  //                 </span>
  //               </div>
  //             </div>
  //             <div className={styles.infoRow}>
  //               <div className={styles.infoLabel}>Total Allowed:</div>
  //               <div className={styles.infoValue}>
  //                 {formatCurrency(claimData.totalAllowedAmount)}
  //               </div>
  //             </div>
  //           </MDBox>
  //         </MDBox>

  //         {/* Services List Section */}
  //         {claimData.services?.length > 0 && (
  //           <MDBox mb={4}>
  //             <MDTypography variant="h5" className={styles.sectionTitle}>
  //               Services
  //             </MDTypography>
  //             <MDBox className={styles.sectionContent}>
  //               <table className={styles.serviceTable}>
  //                 <thead>
  //                   <tr>
  //                     <th>Code</th>
  //                     <th>Description</th>
  //                     <th>Billed Amount</th>
  //                     <th>Allowed Amount</th>
  //                   </tr>
  //                 </thead>
  //                 <tbody>
  //                   {claimData.services.map((service: ClaimService) => (
  //                     <tr key={`${service.code}_${service.id}`}>
  //                       <td>
  //                         <MDTypography variant="button" fontWeight="medium">
  //                           {service.code}
  //                         </MDTypography>
  //                         <MDTypography variant="caption" display="block">
  //                           {service.type}
  //                         </MDTypography>
  //                       </td>
  //                       <td>{service.description}</td>
  //                       <td>
  //                         {formatCurrency(service.billedAmount)}
  //                         {service.medicareMultiplier && (
  //                           <span
  //                             className={`${styles.medicareMultiplier} ${
  //                               styles[
  //                                 getMedicareMultiplierClass(
  //                                   service.medicareMultiplier
  //                                 )
  //                               ]
  //                             }`}
  //                           >
  //                             {formatMedicareMultiplier(
  //                               service.medicareMultiplier
  //                             )}
  //                           </span>
  //                         )}
  //                       </td>
  //                       {/* <td>N/A</td> */}
  //                     </tr>
  //                   ))}
  //                   <tr className={styles.totalRow}>
  //                     <td colSpan={2}>Total</td>
  //                     <td>
  //                       {formatCurrency(claimData.totalBilledAmount)}
  //                       <span
  //                         className={`${styles.medicareMultiplier} ${
  //                           styles[
  //                             getMedicareMultiplierClass(
  //                               claimData.totalMedicareMultiplier
  //                             )
  //                           ]
  //                         }`}
  //                       >
  //                         {formatMedicareMultiplier(
  //                           claimData.totalMedicareMultiplier
  //                         )}
  //                       </span>
  //                     </td>
  //                     <td>{formatCurrency(claimData.totalAllowedAmount)}</td>
  //                   </tr>
  //                 </tbody>
  //               </table>
  //             </MDBox>
  //           </MDBox>
  //         )}

  //         {/* Documents Section */}
  //         <MDBox mb={4}>
  //           <MDTypography variant="h5" className={styles.sectionTitle}>
  //             Documents
  //           </MDTypography>
  //           <MDBox className={styles.sectionContent}>
  //             <MDTypography variant="body2" mb={2}>
  //               The following documents are available for this claim:
  //             </MDTypography>
  //             <div className={styles.documentsGrid}>
  //               {claimData.documents.map((document) => (
  //                 <div
  //                   key={document.id}
  //                   className={styles.documentCard}
  //                   onClick={() => handleDocumentClick(document)}
  //                 >
  //                   <img
  //                     src={document.thumbnailUrl}
  //                     alt={document.title}
  //                     className={styles.documentThumbnail}
  //                   />
  //                   <div className={styles.documentTitle}>{document.title}</div>
  //                   <div className={styles.documentOverlay}>
  //                     <MDButton
  //                       color="white"
  //                       size="small"
  //                       iconOnly
  //                       className={styles.documentOverlayButton}
  //                       onClick={(e) => handleDocumentClick(document)}
  //                     >
  //                       <VisibilityIcon id="view-button" fontSize="medium" />
  //                     </MDButton>
  //                     <MDButton
  //                       color="white"
  //                       size="small"
  //                       iconOnly
  //                       className={styles.documentOverlayButton}
  //                       onClick={(e) => handleDownloadDocument(document, e)}
  //                     >
  //                       <FileDownloadIcon
  //                         id="download-button"
  //                         fontSize="medium"
  //                       />
  //                     </MDButton>
  //                   </div>
  //                 </div>
  //               ))}
  //             </div>
  //           </MDBox>
  //         </MDBox>
  //       </MDBox>
  //     </MDBox>

  //     {/* Document Modal */}
  //     {selectedDocument && (
  //       <div className={styles.documentModal} onClick={handleCloseModal}>
  //         <div
  //           className={styles.documentModalContent}
  //           onClick={(e) => e.stopPropagation()}
  //         >
  //           <button
  //             className={styles.documentModalClose}
  //             onClick={handleCloseModal}
  //           >
  //             <CloseIcon />
  //           </button>
  //           <img
  //             src={selectedDocument.url}
  //             alt={selectedDocument.title}
  //             className={styles.documentModalImage}
  //           />
  //         </div>
  //       </div>
  //     )}
  //   </>
  // );
}
